export default "__VITE_ASSET__DHeeNQ2o__"